import axios from "axios";
import { V1_API_ORIGIN } from "../../config/constants.config";
import axiosInstance from "../axiosInstance";

export const getPackagesService = () => {
  return axiosInstance.get(`${V1_API_ORIGIN}/packages/get-packages?showHide=true`);
}

export const getCategoryWiseService = () => {
  return axiosInstance.get(`${V1_API_ORIGIN}/service-categories?isShow=1`);
}

export const requestSignDocument = (values) => {
  const userId = localStorage.getItem('uid')
  // return axiosInstance.get(`${V1_API_ORIGIN}/e-sign/sign-document/${id}`, {
  //   params: {selectedPlan, ...values, userId}
  // });

  return axiosInstance.post(`${V1_API_ORIGIN}/e-sign/sign-document`, values);
}

export const cancelSignDocument = (id) => {
  return axiosInstance.post(`${V1_API_ORIGIN}/e-sign/cancel-document-sign`, {
    doc_id: id
  });
}

export const paymentOnCashFree = (id, isRecurringPayment) => {
  if (isRecurringPayment) {
    return axiosInstance.get(`${V1_API_ORIGIN}/payments-on-cash-free/subscription/request/${id}`);
  } else {
    return axiosInstance.get(`${V1_API_ORIGIN}/payments-on-cash-free/request/${id}`);
  }
}

export const getBundleService = (id) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/bundles?showHide=true${id ? `&id=${id.id}` : ''}`)
    .then(response => {
      return response.data.data.map((item, index) => {
        delete item.packages
        return item
      });
    });
}

export const digioSignedUpdatePayment = (data) => {
  return axiosInstance.post(`${V1_API_ORIGIN}/payments/update-digio`, {
    ...data
  });
}

export const getKYCDetails = () => {
  const uid = localStorage.getItem('uid');
  return axiosInstance.get(`${V1_API_ORIGIN}/kyc/get-by-userId/${uid}`);
}

const loadedScripts = new Set();

function loadScript(src) {
  return new Promise((resolve, reject) => {
    if (loadedScripts.has(src)) {
      resolve(true); // Script already loaded
      return;
    }

    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      loadedScripts.add(src);
      resolve(true);
    };
    script.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`));
    };
    document.body.appendChild(script);
  });
}

export const paymentRequest = async () => {
  const res = await loadScript(
    "https://checkout.razorpay.com/v1/checkout.js"
  );

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }
  const uid = localStorage.getItem('uid');
  return axiosInstance.get(`${V1_API_ORIGIN}/payments/payment-request/${uid}`);
}

export const updateRazorpaySuccess = (payload) => {
  return axiosInstance.post(`${V1_API_ORIGIN}/payments/update-payment-on-razorpay-success/${window.paymentID}`, payload)
    .then(() => {
      axiosInstance.get(`${V1_API_ORIGIN}/payments/${window.paymentID}`)
        .then(r => {
          axiosInstance.post(`${V1_API_ORIGIN}/payments/${window.paymentID}`, {
            payStatus: r.data.data.payStatus
          })
        })
    });
}

export const submitLead = (payload) => {
  return axiosInstance.post(`${V1_API_ORIGIN}/users/register`, payload)
}

export const getPerformance = (pacId, month, year) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/messages/get-performance?pacId=${pacId}&month=${month}&year=${year}`)
}
export const getPackagePerformance = (pacId, month, year) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/performance?pacId=${pacId}&month=${month}&year=${year}`)
}

export const getInvestorPerformance = (params) => {
  let queryString = `${V1_API_ORIGIN}/investor-performance?`
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      queryString += `${key}=${params[key]}&`;
    }
  }
  return axiosInstance.get(queryString)
}

export const getInvestorPerformanceGraph = () => {
  return axiosInstance.get(`${V1_API_ORIGIN}/investor-performance/get-graph`)
}

export const fetchSubscriptionDataServices = (sid) => {
  return axiosInstance.get(`${V1_API_ORIGIN}/payments-on-cash-free/subscription/fetch/${sid}`);
}

export const storeTimelineServices = (sid) => {
  return axiosInstance.post(`${V1_API_ORIGIN}/timelines`, {
    "type": "pricingPageVisited"
  });
}